/* ============================================================
   TikTok Pixel. Off until a pixel ID is set: either here or in
   REACT_APP_TIKTOK_PIXEL_ID at build time. A pixel ID is public
   (it ships in every page), so it is fine to commit.

   Events are mirrored from trackMeta() in metaPixel.js, so every
   Meta event already wired (PageView, ViewContent, InitiateCheckout,
   Purchase, CompleteRegistration) reaches TikTok too.
   ============================================================ */

// "InstaPass website" pixel in TikTok Events Manager (ad account Instapass0720)
export const TIKTOK_PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID || "DB9KFLBC77UAEK31AND0";

let loaded = false;

function ensureLoaded() {
  if (loaded || !TIKTOK_PIXEL_ID || typeof window === "undefined") return loaded;
  try {
    /* TikTok's standard base code */
    /* eslint-disable */
    !function (w, d, t) { w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=d.createElement("script");n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=d.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};ttq.load(TIKTOK_PIXEL_ID);}(window, document, 'ttq');
    /* eslint-enable */
    loaded = true;
  } catch (e) {
    /* tracking is never allowed to break the page */
  }
  return loaded;
}

const META_TO_TIKTOK = {
  ViewContent: "ViewContent",
  InitiateCheckout: "InitiateCheckout",
  AddToCart: "AddToCart",
  Purchase: "CompletePayment",
  CompleteRegistration: "CompleteRegistration",
  Lead: "SubmitForm",
};

/** Mirror a Meta standard event to TikTok. */
export function trackTikTok(metaEventName, params = {}, eventId) {
  if (!ensureLoaded()) return;
  try {
    const ttq = window.ttq;
    if (metaEventName === "PageView") {
      ttq.page();
      return;
    }
    const name = META_TO_TIKTOK[metaEventName];
    if (!name) return;
    const props = {};
    if (params.value != null) props.value = Number(params.value) || 0;
    if (params.currency) props.currency = params.currency;
    if (params.content_name) props.description = params.content_name;
    if (params.content_ids && params.content_ids.length) {
      props.contents = params.content_ids.map((id) => ({ content_id: String(id), content_type: "product" }));
    }
    ttq.track(name, props, eventId ? { event_id: String(eventId) } : undefined);
  } catch (e) {
    /* never break the page */
  }
}
